// 文件存储API - 完全基于文件系统的存储方案（public/data文件夹）
class FileStorage {
  constructor() {
    this.dataFolder = '/data/'; // 用于读取文章数据
    this.indexFile = 'posts_index.json'; // 索引文件名
  }

  // 获取索引文件路径
  getIndexFilePath() {
    return `${this.dataFolder}${this.indexFile}`;
  }

  // 获取文章文件路径（使用安全的文件名）
  getPostFilePath(post) {
    const safeFileName = this.generateFileName(post.title);
    return `${this.dataFolder}${safeFileName}`;
  }

  // 读取索引文件
  async readIndex() {
    try {
      const response = await fetch(this.getIndexFilePath());
      if (response.ok) {
        const index = await response.json();
        return Array.isArray(index) ? index : [];
      }
      return [];
    } catch (error) {
      console.error('Error reading index file:', error);
      return [];
    }
  }

  // 读取单个文章
  async readPost(postId) {
    try {
      const index = await this.readIndex();
      const postItem = index.find(item => item.id === postId);
      if (!postItem) return null;

      const response = await fetch(postItem.filePath);
      if (response.ok) {
        const post = await response.json();
        return post;
      }
      return null;
    } catch (error) {
      console.error('Error reading post:', error);
      return null;
    }
  }

  // 读取所有文章
  async readAllPosts() {
    try {
      const index = await this.readIndex();
      const posts = [];
      
      for (const item of index) {
        const response = await fetch(item.filePath);
        if (response.ok) {
          const post = await response.json();
          posts.push(post);
        }
      }
      
      return posts;
    } catch (error) {
      console.error('Error reading all posts:', error);
      return [];
    }
  }

  // 生成安全的文件名
  generateFileName(title) {
    return title
      .replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '')
      .substring(0, 50) + '.json';
  }

  // 导出单篇文章功能
  async exportSinglePost(post) {
    try {
      const fileName = this.generateFileName(post.title);
      const options = {
        suggestedName: fileName,
        types: [
          {
            description: 'JSON Files',
            accept: {
              'application/json': ['.json'],
            },
          },
        ],
      };
      
      const fileHandle = await window.showSaveFilePicker(options);
      const writable = await fileHandle.createWritable();
      await writable.write(JSON.stringify(post, null, 2));
      await writable.close();
      
      console.log('Post exported successfully:', fileName);
      return true;
    } catch (error) {
      console.error('Error exporting post:', error);
      return false;
    }
  }

  // 导出所有文章功能
  async exportAllPosts() {
    try {
      const posts = await this.readAllPosts();
      const options = {
        suggestedName: `blog_posts_${new Date().toISOString().split('T')[0]}.json`,
        types: [
          {
            description: 'JSON Files',
            accept: {
              'application/json': ['.json'],
            },
          },
        ],
      };
      
      const fileHandle = await window.showSaveFilePicker(options);
      const writable = await fileHandle.createWritable();
      await writable.write(JSON.stringify(posts, null, 2));
      await writable.close();
      
      console.log('All posts exported successfully');
      return true;
    } catch (error) {
      console.error('Error exporting all posts:', error);
      return false;
    }
  }

  // 生成手动保存的文件内容（用于复制到public/data文件夹）
  generateFileContentForManualSave(post) {
    const fileName = this.generateFileName(post.title);
    const fileContent = JSON.stringify(post, null, 2);
    
    return {
      fileName: fileName,
      filePath: `/data/${fileName}`,
      content: fileContent
    };
  }

  // 检查文件系统是否已启用
  isFileSystemEnabled() {
    return true;
  }
}

// 创建单例实例
const fileStorage = new FileStorage();

export default fileStorage;